export default __webpack_public_path__ + "static/banner-creditline-fa403540feedc338426000734903cf67.jpg";